import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import { useStringMap } from "../utilities/string-map/useStringMap";
import { Popper } from "../popper/Popper";
import { useUniqueId } from "../hooks/useUniqueId";
import { HelpIcon } from "../icons/HelpIcon";
import * as Styled from "./HelpPopover.styled";
import { stringMapDefault } from "./HelpPopover.stringMap";
const renderDefaultTrigger = ({ "aria-label": ariaLabel, className, size }) => (_jsx(Styled.HelpIconButton
// Not needed if event handling is set up correctly, consider removing later and fixing directly in Field and other components that render help inside a clickable area
, { 
    // Not needed if event handling is set up correctly, consider removing later and fixing directly in Field and other components that render help inside a clickable area
    onClick: (e) => {
        e.stopPropagation();
    }, "aria-label": ariaLabel, className: className, children: _jsx(HelpIcon, { size: size, palette: "interactiveConstructive", "aria-hidden": "true", viewBox: "0 0 16 16" }) }));
const componentName = "HelpPopover";
export const HelpPopover = forwardRef((props, _ref) => {
    const { children, placement, size, className, stringMap: stringMapProp, popoverWidth, renderTrigger = renderDefaultTrigger, "aria-label": ariaLabel, ...otherProps } = props;
    const stringMap = useStringMap(componentName, { stringMapDefault, stringMapProp });
    const helpIconSize = useMemo(() => {
        if (typeof size === "number") {
            return size;
        }
        switch (size) {
            case "small":
                return 12;
            case "medium":
                return 16;
            case "large":
                return 24;
            default:
                return 12;
        }
    }, [size]);
    const trigger = renderTrigger({ "aria-label": ariaLabel ?? stringMap.helpPopover, size: helpIconSize, className });
    const popoverId = useUniqueId();
    return (_jsx(Popper, { "data-testid": "HelpPopover", mode: "popover", overlay: ({ closeAndReturnFocus }) => (_jsxs(Styled.HelpContentBox, { hasArrow: true, role: "dialog", "aria-roledescription": "popover", "aria-labelledby": popoverId, maxWidth: popoverWidth || "320px", children: [_jsx(Styled.CloseIconButton, { onClick: closeAndReturnFocus, "aria-label": stringMap.close }), _jsx("div", { id: popoverId, children: children })] })), trigger: trigger, ...otherProps }));
});
HelpPopover.displayName = componentName;
